import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumbs.module.css';

const Breadcrumbs = ({ paths = [] }) => {
  if (paths.length === 0) return null;

  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      <ol className={styles.breadcrumbList}>
        {paths.map((item, idx) => {
          const isLast = idx === paths.length - 1;
          
          return (
            <li key={idx} className={`${styles.breadcrumbItem} ${isLast ? styles.active : ''}`}>
              {item.to && !isLast ? (
                <Link to={item.to} className={styles.breadcrumbLink}>
                  {item.label}
                </Link>
              ) : (
                <span className={styles.breadcrumbCurrent} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              
              {!isLast && (
                <span className={styles.separator} aria-hidden="true">/</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
